import React, { Suspense } from 'react';
import { ApplicationAuthConfig } from '@tanium-cloud/tsp-contracts';
import { useCognitoAuth, AuthState } from '../../auth/useCognitoAuth';
import { removeCSRFToken } from '../../auth/getCSRFToken';
import { FullPageSpinner } from '../FullPageSpinner';
import { noop } from '../../utilities/commonFuncs';

const AuthenticatedArea = React.lazy(() => import('../AuthenticatedArea/AuthenticatedArea'));
const UnauthenticatedArea = React.lazy(() => import('../UnauthenticatedArea/UnauthenticatedArea'));

interface Props {
  authConfig: ApplicationAuthConfig;
}

export const AppContainer: React.VFC<Props> = ({ authConfig }) => {
  const cognitoAuth = useCognitoAuth(authConfig, noop, removeCSRFToken);
  const { session, authState } = cognitoAuth;

  if (authState === AuthState.LOADING) {
    return <FullPageSpinner />;
  }

  return (
    <Suspense fallback={<FullPageSpinner />}>
      {authState === AuthState.SIGNED_IN && session ? (
        <AuthenticatedArea session={session} />
      ) : (
        <UnauthenticatedArea cognitoAuth={cognitoAuth} />
      )}
    </Suspense>
  );
};
